import { Article_article } from '@graphql/__generated__/Article'

const uspsDefault = {
  nl: [
    'Voor 15:00 besteld, dezelfde dag verzonden',
    'Gratis verzenden & retourneren',
    'Altijd verzekerd'
  ],
  en: [
    'Ordered before 3 P.M, shipped the same day (only in The Netherlands)',
    'Free shipping & returns',
    'Always insured'
  ]
}
const uspsAlternative = {
  nl: ['Breed assortiment merken en producten', 'Persoonlijke service', 'Altijd verzekerd'],
  en: ['Wide range of brands and products', 'Always personal advice', 'Always insured']
}
type ProductInformation = {
  buttons: string[]
  title: string | null
  label: string | null
  usps: string[]
}

export const getProductInformationProps = (
  props: Article_article,
  lang: string
): ProductInformation => {
  if (props.isOutOfCollection && !props.inStock && !props.ignoreStockCheck) {
    return {
      buttons: ['appointment', 'question'],
      title:
        lang === 'nl'
          ? 'Product is niet in voorraad en niet meer leverbaar'
          : 'Product is out of stock and discontinued.',
      label:
        lang === 'nl'
          ? 'Neem contact met ons op voor vragen over alternatieve producten.'
          : 'Contact us for alternatives and questions',
      usps: uspsAlternative[lang]
    }
  }

  if (!props.inStock && !props.ignoreStockCheck) {
    // This article is not in stock and ignoreStock is false
    return {
      buttons: ['appointment', 'question'],
      title: lang === 'nl' ? 'Product is niet in voorraad' : 'Product is not in stock',
      label:
        lang === 'nl'
          ? 'Neem contact met ons op voor vragen over de beschikbaarheid van dit product.'
          : 'Please contact us for any questions about the availability of this product.',
      usps: uspsAlternative[lang]
    }
  }

  if (!props.isWebshopSale) {
    // This article is not available online
    return {
      buttons: ['appointment', 'question'],
      title:
        lang === 'nl' ? 'Product is niet online beschikbaar' : 'Product is not available online',
      label:
        lang === 'nl'
          ? 'U kunt vrijblijvend langskomen in onze boutiques of neem contact met ons op voor uw vragen.'
          : 'You are welcome to visit us at one of our Boutiques or contact us for your questions.',
      usps: uspsAlternative[lang]
    }
  }

  if (props.isWebShopOnly) {
    // This article is only available
    return {
      buttons: ['order', 'question'],
      title:
        lang === 'nl' ? 'Product is alleen online beschikbaar.' : 'Product only available online.',
      label:
        lang === 'nl'
          ? 'Dit product is alleen beschikbaar online en niet in één van onze winkels.'
          : 'This product is only availble only and not in one of our stores.',
      usps: uspsAlternative[lang]
    }
  }

  if (!props.isPriceVisible) {
    return {
      buttons: ['appointment', 'question'],
      title: lang === 'nl' ? 'Prijs is niet online beschikbaar' : 'Prijs is not available online',
      label:
        lang === 'nl'
          ? 'U kunt vrijblijvend langskomen in onze boutiques of neem contact met ons op voor uw vragen.'
          : 'You are welcome to visit us at one of our Boutiques or contact us for your questions.',
      usps: uspsAlternative[lang]
    }
  }

  const delivery = props.articleAttributes.find(attr => attr.attributeID === 33)
  if (delivery) {
    let label = ''
    let title = ''
    const productType =
      props.articleType === 'Horloge'
        ? lang === 'nl'
          ? 'horloge'
          : 'watch'
        : lang === 'nl'
        ? 'juweel'
        : 'juwel'

    if (delivery.attributeValue === 'Delivery_4' || delivery.attributeValue === 'Delivery_6') {
      title = lang === 'nl' ? 'Levertijd' : 'Delivery time'
      label =
        lang === 'nl'
          ? `Dit ${productType} wordt speciaal op aanvraag voor u besteld. De levertijd van dit ${productType} is ongeveer ${
              delivery.attributeValue === 'Delivery_4' ? '4' : '6'
            } weken `
          : `This ${productType} will be specially ordered for you on request. The delivery time of this ${productType} is ${
              delivery.attributeValue === 'Delivery_4' ? '4' : '6'
            } weeks.`
    }
    if (
      delivery.attributeValue === 'Delivery_4_size' ||
      delivery.attributeValue === 'Delivery_6_size'
    ) {
      title = lang === 'nl' ? 'Levertijd' : 'Delivery time'
      label =
        lang === 'nl'
          ? `Wij doen er alles aan om dit ${productType} direct te leveren in de gewenste maat. Mocht de voorraad dit niet toelaten, bestellen wij dit ${productType} speciaal voor u en is de levertijd ongeveer ${
              delivery.attributeValue === 'Delivery_4_size' ? '4' : '6'
            } weken.`
          : `We do everything we can to deliver this ${productType} directly in the desired size. If the stock does not allow this, we will order this ${productType} especially for you and the delivery time is approximately ${
              delivery.attributeValue === 'Delivery_4_size' ? '4' : '6'
            } weeks.`
    }
    return {
      buttons: ['order', 'appointment'],
      title: title,
      label: label,
      usps: uspsAlternative[lang]
    }
  }

  return {
    buttons: ['order', 'appointment'],
    title: null,
    label: null,
    usps: uspsDefault[lang]
  }
}
